// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import * as L from 'leaflet';
import * as _ from 'lodash';

/**
 * Environment configuration for the new Admin Live setup.
 * 
 * This fix is applied to restrict the visibility of environment.json
 * in the deployed application (ensuring sensitive config is not exposed).
 */

export interface Tile {
  type: string;
  url: string;
  options?: L.TileLayerOptions;
  layer?: L.TileLayer;
}

export interface LeafletConfig {
  tiles: {
    [key: string]: Tile;
  };
}

export interface Environment {
  production: boolean;
  PAPI_BASE_PATH: string;
  TEZZ_ADD_PAPI_PATH: string;
  PULSE_BASE_PATH: string;
  authkeys: {
    PAA_AUTH_TOKEN: string;
    PAA_COGNITO_TOKEN: string;
  };
  cognito: {
    appName: string;
    authDomain: string;
    lookupDomain: string;
    redirectUri: string;
    pollInterval: number;
    refreshTolerence: number;
  };
  geocode: {
    provider: string;
    googleMaps: {
      apiKey: string;
      url: string;
    };
    mapbox: {
      accessToken: string;
      geocodeUrl: string;
    };
  };
  leaflet: LeafletConfig;
  ROOT_ORGS: string[];
}

export const environment: Environment = {
  production: false,
  PAPI_BASE_PATH: "https://dev-az.tez-papi.tezzeract.ai/v1",
  TEZZ_ADD_PAPI_PATH: "https://illum-add-papi.tezzeract.ai/api",
  PULSE_BASE_PATH: "https://illum-live.tezzeract.ai/integration-manager",
  authkeys: {
    PAA_AUTH_TOKEN: "PAA_AUTH_TOKEN",
    PAA_COGNITO_TOKEN: "PAA_COGNITO_TOKEN"
  },
  cognito: {
    appName: "arcangel-admin",
    authDomain: "https://cognito-development.tezzeract.ai",
    lookupDomain: "https://domain-lookup-development.tezzeract.ai",
    redirectUri: "https://illumadmin.tezzeract.ai/login",
    pollInterval: 1,
    refreshTolerence: 10
  },
  geocode: {
    provider: "googleMaps",
    googleMaps: {
      apiKey: "AIzaSyBcniHaWDiQa5eLutylzF2EagwqtO-cOxM",
      url: "https://maps.googleapis.com/maps/api/js?libraries=places&loading=async&key={{APIKEY}}"

    },
    mapbox: {
      accessToken: "pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ",
      geocodeUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places/"
    }
  },
  leaflet: {
    tiles: {
      Street: {
        type: 'mapbox',
        url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/{z}/{x}/{y}{r}',
        options: { detectRetina: true, maxZoom: 25, maxNativeZoom: 19 }
      },
      Satellite: {
        type: 'mapbox',
        url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/{z}/{x}/{y}{r}',
        options: { detectRetina: true, maxZoom: 25, maxNativeZoom: 19 }
      }
    }
  },
  ROOT_ORGS: []
};